import { getBase64 } from "../List/ImageToBase64"


export function getOwnerLogo(id){
    const images = [
        {
            owner_id:  1,
            image: require("../../image/owner1_logo.png") 
        },
        {
            owner_id:  2,
            image: require("../../image/owner2_logo.png") 
        },
        {
            owner_id:  3,
            image: require("../../image/owner3_logo.png") 
        },
        {
            owner_id:  4,
            image: require("../../image/owner4_logo.png") 
        },
        {
            owner_id:  58,
            image: require("../../image/46.png") 
        }
    ]

    const image = images.find(image => image.owner_id === parseInt(id))
    
    // const image = require("../../image/46.png")
    console.log(image, id);
    return getBase64(image ? image.image : "");
    // const img="R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==";
    // return img;
    
}
